import React from 'react'

export function Box({
  children,
  disabled = false,
  className = '',
}: React.PropsWithChildren<{ className?: string; disabled?: boolean }>) {
  const classNames = `bg-white shadow overflow-hidden sm:rounded-lg mx-4 ${className} ${
    disabled ? 'opacity-50' : ''
  }`
  return (
    <div className={classNames}>
      <div className="px-4 py-5 sm:px-6">{children}</div>
    </div>
  )
}
